import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function SubscriptionManagement() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Customer Name	",
      accessorKey: "CustomerName",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "Package Name	",
      accessorKey: "PackageName",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
    },
    {
      header: "Expire Date	",
      accessorKey: "ExpireDate",
    },
    {
      header: "Status",
      accessorKey: "Status",
    },

    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },
  ]);
  const [data] = useState([
       {
        SN: 1,
        CustomerName: "Zohaib",
        Phone: 9663441312900,
        PackageName: "Super Hot Daal",
        Amount: 500,
        PaymentMethod: "Cash",
        ExpireDate:"24-01-01",
        Status: "Approve"
       },
       {
        SN: 2,
        CustomerName: "Syed Saad Imam	",
        Phone: 9663350138248,
        PackageName: "Package for Company	",
        Amount: 600,
        PaymentMethod: "Cash",
        ExpireDate:"23-11-01",
        Status: "Approve"
       },

    
  ]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        
       
      />
    </main>
  );
}

export default SubscriptionManagement;
